import { render, staticRenderFns } from "./crudInstancesSystemOthers.vue?vue&type=template&id=35c844c4&scoped=true&"
import script from "./crudInstancesSystemOthers.vue?vue&type=script&lang=js&"
export * from "./crudInstancesSystemOthers.vue?vue&type=script&lang=js&"
import style0 from "./crudInstancesSystemOthers.vue?vue&type=style&index=0&id=35c844c4&prod&lang=css&"
import style1 from "./crudInstancesSystemOthers.vue?vue&type=style&index=1&id=35c844c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c844c4",
  null
  
)

export default component.exports